var ROUTE_TYPES = new Map([['bicycle', 'на велосипеде'], ['driving', 'на машине'], ['masstransit', 'транспортом'], ['pedestrian', 'пешком']]);
export var getRouteInfo = function getRouteInfo(route) {
  var distance = route.distance,
    type = route.type;
  var duration = route.durationInTraffic || route.duration;
  return "".concat(duration.text, " ").concat(ROUTE_TYPES.get(type), " ").concat(distance.text);
};